import { AbstractStep } from "@component/assets/AbstractLeadForm/Steps/AbstractStep";
import { List } from "bm-ui-kit";
import type { ReactNode } from "react";
import React from "react";
import { Alert, Card } from "react-bootstrap";

export class Error extends AbstractStep {
	protected renderContent(): ReactNode {
		return (
			<>
				<Card.Header className="text-center text-white bg-danger">
					<Card.Title>Sajnos nem találtunk a megadott feltételeknek megfelelő hitelt.</Card.Title>
				</Card.Header>
				<Card.Body>
					<div className="h6">Próbálj meg enyhíteni a feltételeken:</div>
					<Alert variant="info">
						<List itemStyle="info-circle" variant="info" className="mb-0">
							<List.Item>Csökkentsd a felvenni kívánt hitelösszeget</List.Item>
							<List.Item>Növeld a futamidőt</List.Item>
							<List.Item>Várj még pár hónapot hogy meglegyen a megfelelő munkaviszony hossza.</List.Item>
						</List>
					</Alert>
				</Card.Body>
			</>
		);
	}

	protected getComponentName(): string {
		return "Error";
	}
}
